<template>
  <base-modal modal-content-class="resub">
    <div class="content">
      <h1>
        {{ getTranslations.home_modals_welcome_back_returning_back_welcome_back }}
        <div><span>{{ userDetails.username }}</span></div>
      </h1>

      <p>{{ getTranslations.home_modals_welcome_back_you_start }}</p>

      <p>{{ getTranslations.home_modals_welcome_back_go_to_profile_page }}</p>

      <base-button container-class="resub_btn" @button:click="handleRedirection">
        {{ getTranslations.home_modals_welcome_back_profile_page_button }}
      </base-button>
    </div>
  </base-modal>
</template>

<script>
import {mapState, mapGetters, mapMutations} from 'vuex'
import BaseModal from '../../common/modal/BaseModal'
import BaseButton from '../../common/button/BaseButton'
import modals from '../../../common/modals'

export default {
  name: 'welcome-returning-unsub',
  components: {
    BaseModal,
    BaseButton
  },
  computed: {
    ...mapState('common', [
      'userDetails'
    ]),
    ...mapGetters('i18n', [
      'getTranslations'
    ])
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForStore',
      'storeModalForSettings',
      'storeModalForHomePage'
    ]),
    handleRedirection () {
      const redirectionPath = '/home'
      const isRedirectionNeeded = sessionStorage.getItem('homeCurrentTabPath') !== redirectionPath

      modals.hideCommonModal({
        immediate: isRedirectionNeeded,
        afterHideCallback: () => {
          this.storeModalForStore(null)
          this.storeModalForSettings(null)
          this.storeModalForHomePage(null)

          if (isRedirectionNeeded) {
            this.$router.push(redirectionPath)
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/modals/WelcomeReturningUnsub.vue